import { useQuery } from "@tanstack/react-query";

import { getFootprintingCropSalesByPrimaryDataId, getFootprintingCropSalesByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_SALES } from "consts";

export const useGetFootprintingCropSales = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getFootprintingCropSalesByPrimaryDataIdAdmin : getFootprintingCropSalesByPrimaryDataId;

  return useQuery({
    queryKey: [FOOTPRINTING_CROP_SALES, primaryDataId],
    queryFn: () => queryFn(primaryDataId),
    enabled: !!primaryDataId,
  });
};
